import { DocumentData, Query, Unsubscribe } from "firebase/firestore";
import { onCollectionSnapshot } from "api/repositories/FirebaseRepository";
import WBSRowModel from "../models/WBSRowModel";
import WBSModel from "../models/WBSModel";

export const maxRowsAtSnapshot = 3000;

class WBSService<T extends WBSRowModel> {
  private rowsObservers: any[] = [];

  protected addSnapshot(
    rowsList: WBSModel<T>,
    queryRef: Query<DocumentData>,
    onCreate: (data: T[], isFinishing: boolean) => void,
    onChange?: (data: T[]) => void,
    onFinish?: Function
  ) {
    const onCreateCallback = (rows) => {
      if (onCreate) onCreate(rows, rows.length < maxRowsAtSnapshot);

      if (rows.length < maxRowsAtSnapshot) {
        rowsList.markAsComplete();
        if (onFinish) onFinish();
      }
    };

    const onChangeCallback = (rows) => {
      if (onChange) onChange(rows);
    };

    const observer = onCollectionSnapshot<T>(
      queryRef,
      onCreateCallback,
      onChangeCallback,
      () => {},
      (error) => console.error("WBSRowsSnapshot", error)
    );
    this.addObserver(observer);
  }

  protected addObserver(observer: Unsubscribe) {
    this.rowsObservers.push(observer);
  }

  protected removeRowsSnapshots() {
    this.rowsObservers.forEach((observer) => observer());
    this.rowsObservers = [];
  }
}

export default WBSService;
